import { CookieStorageKeysInterface } from './types';

export enum CookieStorageKeyEnums {
  AUTH_TOKEN,
}

export const CookieStorageKeys: CookieStorageKeysInterface = {
  AUTH_TOKEN: 'AUTH_TOKEN',
};
